import version from '../../package.json';

export const environment = {
  production: true,
  hmr: false,
  version: version.version,
  envName: 'prod',
  environmentName: 'PROD',
  origins: ['https://payment.archinsurance.com', 'https://billing-portal.archinsurance.io'],
  appUrl: 'https://payment.archinsurance.com',
  AIP_AGENCY_ROLE: 'AIGI-ROLE-DIGAIP-AGENCY',
  AIP_ADMIN_ROLE: 'ADMIN',
  aipHostPort: 'http://aigi-drvjbss001:8080/',
  billingPortalApiHost: 'https://payment.archinsurance.com/api/',
  billingPortalConsumerApiHost: 'https://payment.archinsurance.com/api-con/',
  bopQuoteEndPoint: 'api/quote',
  chaseCallBackUrl: 'https://payment.archinsurance.com/success/',
  hostedChaseCallBackUrl: 'https://payment.archinsurance.com/hosted/success/',
  aipHostPortAdmin: 'https://portal.archinsurance.com',
  paymentUsIframe: 'https://ipn4.paymentus.com/xotp/pm/aidc?authToken=',
  paymentUsOrigin: 'https://ipn4.paymentus.com',
  postMessagePmDetailsOrigin: {
    agent: 'https://payment.archinsurance.com/payer-info',
    consumer: 'https://payment.archinsurance.com/direct/payment',
  },
  chaseOrigin: {
    version2: {
      origin: 'https://www.chasepaymentechhostedpay.com',
      iframeOrigin: `https://www.chasepaymentechhostedpay.com`,
    },
    version3: {
      origin: 'https://chase.hostedpaymentservice.net',
      iframeOrigin: `https://chase.hostedpaymentservice.net`,
    },
  },

  aipHostPortMenu: 'https://portal.archinsurance.com/api-menu/',
  aipHostPortBase: 'https://aip-base-api-prod.apps.aks-nonprod.archinsurance.com',
  aipHostPort1: 'https://aip-base-api-prod.apps.aks-nonprod.archinsurance.com/aip-base-api/aip-base-api',
  aipHostPort2: 'https://aip-authorization-ms-prod.apps.aks-nonprod.archinsurance.com',
  pgrRedirectUrl: 'aHR0cHM6Ly9idXNpbmVzc3F1b3RlLnByb2dyZXNzaXZlY29tbWVyY2lhbC5jb20vYXJjaGNvbmZpcm1hdGlvbg==', //default redirectUrl for Progressive.

  //ROLE
  internal: 'ARCH',
  external: 'AGENCY',
  admin: 'ADMIN',
  internalUser: 'Internal',
  externalUser: 'External',
  INTERNAL_EMAIL_DOMAIN: [
    'archinsurance.com',
    'archgroup.com',
    'archcapservices.com',
    'archgso.com',
    'corp.archcapservices.com',
  ],
  SKIP_PORTALS_INTERNAL_USER: ['AIGI-BasePortal'],
  AUTO_PORTALS_INTERNAL_USER: [{ 'AIGI-BasePortal': 'AIGI-ROLE-DIGAIP-ARCH-UNDERWRITER' }],
  LAUNCHDARKLY_CLIENTID: '635fd8a8f772dc0bdb58c32e',
};
